import styled from "styled-components";

const Container = styled.div`
  padding: 0;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: ${({ $autoHeight }) => ($autoHeight ? "0" : "400px")};

  img.icon,
  MuiTooltip-tooltip img.icon {
    height: 15px;
    width: 15px;
    margin-right: 4px;
    margin-bottom: -3px;
    filter: invert(30%);
  }

  .MuiDataGrid-columnHeaderTitleContainer {
    color: white;
    background-color: #555;
    height: 40px;
    overflow: hidden;
  }

  .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-sortIcon {
    color: white;
  }

  .MuiDataGrid-menuIcon > button > svg {
    color: white;
  }

  .MuiDataGrid-columnHeaderTitleContainerContent
    > .MuiCheckbox-root
    > .MuiSvgIcon-root {
    color: rgba(255, 255, 255, 0.7);
    &:hover {
      color: white;
    }
  }

  .MuiDataGrid-cell {
    position: relative;
  }

  .MuiDataGrid-cell p {
    margin: 0;
  }

  .MuiDataGrid-cell .comment-cell {
    height: 75%;
    width: 100%;
    overflow: hidden;
  }

  .MuiDataGrid-cell svg.lease-name-icon {
    margin-right: 5px;
  }

  .MuiDataGrid-cell .clickable {
    font-weight: bold;
  }

  .MuiDataGrid-cell .tooltip-button-container {
    position: absolute;
    right: 15px;
    top: 7px;
  }

  .MuiDataGrid-cell button.leaseEvents.tooltip-button {
    background: #eee;
    margin-top: 5px;
    border-radius: 20px;
    padding: 4px 10px;
    min-width: 25px;
    color: black;
  }

  .MuiButton-root.filter {
    margin-bottom: 15px;
    width: 130px;
  }

  .MuiOutlinedInput-root.search {
    position: absolute;
    right: 0;
    top: 20px;
    height: 35px;
  }

  .MuiOutlinedInput-root.MuiInputBase-root.filter {
    width: 100%;
    height: 50px;
  }

  .MuiTextField-root.notice-date-ranges {
    position: absolute;
    right: 0;
    top: 70px;
  }

  .MuiTextField-root.notice-date-ranges .MuiOutlinedInput-root {
    width: 170px;
    height: 35px;
  }

`;

const TableContainer = styled.div`
  width: 100%;
`;

export { Container, TableContainer };
